module.exports = "<div class=\"icon\" [attr.data-name]=\"name\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/generic/icon/icon.component.html
// module id = ../../../../../src/app/generic/icon/icon.component.html
// module chunks = main